module.exports = __webpack_public_path__ + "static/media/icon-youtube.7e768d00.svg";